import { render } from "./PricingTable.vue?vue&type=template&id=457811ac&scoped=true"
const script = {}

import "./PricingTable.vue?vue&type=style&index=0&id=457811ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457811ac"]])

export default __exports__